import { DefaultError } from 'errors/DefaultError';

export class ReactRenderingError extends DefaultError {
  constructor({ error, errorInfo }) {
    super({ error, name: ReactRenderingError.name });

    this.stack = errorInfo;
  }
  static get name() {
    return 'ReactRenderingError';
  }
}
